import React, { useEffect, useState } from 'react';
import { getPublicUrl } from '../../../appconfig';
import AboutLinksSection from '../../HomePage/NewFooter/AboutandLinks';
import FootNoteNew from '../../HomePage/NewFooter/FootNote/FootNoteNew';
import { FootNoteNewStyle } from '../../HomePage/NewFooter/FootNote/styled';
import SocialIcons from '../../HomePage/NewFooter/SocialIcons';
import RaiseHappinessSection from '../RaiseHappinessSection';
import { FooterContentSection, NewFooterSection } from './styled';
import BannerSection from '../../HomePage/NewFooter/BannerSection';

const StoreFooter = (props) => {
  let {
    priceRateMerge,
    faqsData,
    content,
    alsoSearchFor,
    screen,
    priceTable,
    ratingTable,
    updatedOn,
    categoryData,
    productId,
    altFooter,
    isAboutUsPage,
  } = props;
  const [footnoteIngredientData, setFootnoteData] = useState(null);
  useEffect(() => {
    let urls = [];
    categoryData?.map((category) => {
      category?.subCategories?.map((element) => {
        let obj = {
          name: element?.tabName,
          deeplinkValue: element?.key,
          categories: [],
        };
        if (element?.subCategories) {
          element?.subCategories?.map((item) => {
            if (item.tabName?.includes('Ingredient')) {
              item?.subCategories?.map((cat) => {
                let obj = {
                  name: cat.tabName,
                  key: cat.key || cat.deepLink,
                };
                urls.push(obj);
              });
            }
          });
          // categoryManipulatedData.push(obj);
        } else {
          // categoryManipulatedData.push(element);
        }
      });
    });
    setFootnoteData(urls);
  }, []);

  useEffect(() => {
    // console.log(footnoteIngredientData);
  }, [footnoteIngredientData]);
  return (
    <NewFooterSection>
      {altFooter ? (
        <>
          <div className="footnote">
            <FootNoteNew
              priceRateMerge={priceRateMerge}
              faqsData={faqsData}
              content={content}
              alsoSearchFor={alsoSearchFor}
              screen={screen}
              updatedOn={updatedOn}
              productId={productId}
              ratingTable={ratingTable}
              priceTable={priceTable}
            />
            {footnoteIngredientData?.length > 0 ? (
              <FootNoteNewStyle>
                <h3>Shop By Ingredient:</h3>
                <p>
                  {footnoteIngredientData?.map((data, index) => {
                    return (
                      <>
                        <a
                          key={'footnote' + index}
                          href={getPublicUrl() + data?.key}
                        >
                          {data?.name}
                        </a>
                        {' | '}
                      </>
                    );
                  })}
                </p>
              </FootNoteNewStyle>
            ) : null}
          </div>
          <RaiseHappinessSection />
          <FooterContentSection>
            <AboutLinksSection />
          </FooterContentSection>
          <div className="social">
            <SocialIcons />
          </div>
        </>
      ) : (
        <>
          <BannerSection isAboutUsPage={isAboutUsPage} />
          <RaiseHappinessSection isAboutUsPage={isAboutUsPage} />
          <FooterContentSection>
            <AboutLinksSection />
          </FooterContentSection>
          <div className="social">
            <SocialIcons />
          </div>
          <div className="footnote">
            <FootNoteNew
              priceRateMerge={priceRateMerge}
              faqsData={faqsData}
              content={content}
              alsoSearchFor={alsoSearchFor}
              screen={screen}
              updatedOn={updatedOn}
              productId={productId}
              ratingTable={ratingTable}
              priceTable={priceTable}
            />
            {footnoteIngredientData?.length > 0 ? (
              <FootNoteNewStyle>
                <h3>Shop By Ingredient:</h3>
                <p>
                  {footnoteIngredientData?.map((data, index) => {
                    return (
                      <>
                        <a
                          key={'footnote' + index}
                          href={getPublicUrl() + data?.key}
                        >
                          {data?.name}
                        </a>
                        {' | '}
                      </>
                    );
                  })}
                </p>
              </FootNoteNewStyle>
            ) : null}
          </div>
        </>
      )}
    </NewFooterSection>
  );
};

export default StoreFooter;
